import React from "react";
import { Link } from "react-router-dom";
import PlaceholderImage from "./PlaceholderImage";
import { PRODUCT_LISTING } from "@/data/assets";

/**
 * Product listing tile — matches USA product-card style:
 * white background, big product shot on top, bold uppercase name, price below.
 */
export default function ProductCard({ product, testId, placeholderLabel, imgSrc }) {
  const label = placeholderLabel || `Product Listing – ${product.name}`;
  const src = imgSrc || PRODUCT_LISTING[product.slug];

  return (
    <Link
      to={`/products/${product.slug}`}
      data-testid={testId || `product-card-${product.slug}`}
      className="group block bg-white border border-black/10 hover:border-black transition-colors"
    >
      <div className="relative overflow-hidden">
        <PlaceholderImage
          ratio="square"
          label={label}
          testId={`product-card-image-${product.slug}`}
          src={src}
          alt={product.name}
          className="transition-transform duration-500 group-hover:scale-[1.03]"
        />
        <div className="absolute inset-x-0 bottom-0 py-3 bg-black text-white text-center opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="font-heading uppercase tracking-[0.24em] text-[11px] font-semibold">
            Quick View
          </span>
        </div>
      </div>
      <div className="p-6 text-center">
        <h3 className="font-display text-2xl sm:text-3xl uppercase leading-none text-black">
          {product.name}
        </h3>
        <div className="mt-3 flex items-center justify-center gap-2 flex-wrap">
          <span className="font-display text-2xl leading-none text-black">
            {product.priceLabel}
          </span>
          <span className="font-heading uppercase tracking-[0.1em] text-sm text-black/45 line-through">
            MRP {product.mrpLabel}
          </span>
        </div>
        <div className="mt-3">
          <span className="mp-save-badge">Save {product.discountPercent}%</span>
        </div>
      </div>
    </Link>
  );
}
